import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const styles = tv({
  slots: {
    viewport: `
      iris:fixed
      iris:bottom-0
      iris:left-1/2
      iris:z-100
      iris:flex
      iris:w-full
      iris:-translate-x-1/2
      iris:transform
      iris:flex-col
      iris:items-center
      iris:gap-2
      iris:p-6
      iris:outline-none
      iris:md:top-0
      iris:md:bottom-auto
    `,
    root: `
      iris:relative
      iris:flex
      iris:max-w-[720px]
      iris:items-center
      iris:overflow-hidden
      iris:rounded-(--comp-size-radius-toast)
      iris:bg-(--comp-color-background-toast-default)
      iris:px-(--comp-space-padding-toast-horizonal)
      iris:py-(--comp-space-padding-toast-vertical)

      iris:data-[state=hide]:animate-[fadeIn_var(--comp-motion-duration-toast-exit)_var(--comp-motion-easing-toast-exit,ease-out)_forwards]
      ${focusStyles.default}
    `,
    container: `
      iris:flex
      iris:items-center
      iris:gap-(--comp-space-gap-toast-icon)
      iris:pr-[32px]
    `,
    icon: `
      iris:size-[32px]
      iris:shrink-0
      iris:text-(--comp-color-content-toast-icon)
    `,
    content: "iris:gap-(--comp-space-gap-toast-text)",
    titleBox: "iris:font-(family-name:--comp-type-font-toast-title)",
    title: `
      iris:text-(length:--comp-type-size-toast-title)
      iris:leading-(--comp-type-leading-toast-title)
      iris:font-(--comp-type-weight-toast-title)
      iris:tracking-(--comp-type-tracking-toast-title)
      iris:text-(--comp-color-content-toast-title)
    `,
    messageBox: `
      iris:inline
      iris:items-end
      iris:font-(family-name:--comp-type-font-toast-body)
    `,
    message: `
      iris:inline
      iris:text-(length:--comp-type-size-toast-body)
      iris:leading-(--comp-type-leading-toast-body)
      iris:font-(--comp-type-weight-toast-body)
      iris:tracking-(--comp-type-tracking-toast-body)
      iris:text-(--comp-color-content-toast-body)
    `,
    link: `
      iris:ml-1
      iris:cursor-pointer
      iris:text-(length:--comp-type-size-toast-body)
      iris:text-(--comp-color-content-link-inverse-rest)
      iris:underline
      iris:hover:text-(--comp-color-content-link-inverse-hover)

      iris:active:text-(--comp-color-content-link-inverse-pressed)
      ${focusStyles.inverse}
    `,
    closeButton: `
      iris:absolute
      iris:top-0
      iris:right-0
      iris:m-(--comp-space-padding-toast-horizonal)
    `
  },
  variants: {
    swipeDirection: {
      up: {
        root: `
          iris:data-[swipe=end]:animate-topToastOut
          iris:data-[state=closed]:animate-[topToastOut_var(--comp-motion-duration-toast-exit)_var(--comp-motion-easing-toast-exit)_forwards]
          iris:data-[state=open]:animate-[topToastIn_var(--comp-motion-duration-toast-entry)_var(--comp-motion-easing-toast-entry)_forwards]
          iris:data-[swipe=cancel]:translate-y-0
          iris:data-[swipe=cancel]:transition-[transform_var(--comp-motion-duration-toast-entry)_var(--comp-motion-easing-toast-entry)]
          iris:data-[swipe=move]:translate-y-[var(--radix-toast-swipe-move-y)]
        `
      },
      down: {
        root: `
          iris:data-[swipe=end]:animate-bottomToastOut
          iris:data-[state=closed]:animate-[bottomToastOut_var(--comp-motion-duration-toast-exit)_var(--comp-motion-easing-toast-exit)_forwards]
          iris:data-[state=open]:animate-[bottomToastIn_var(--comp-motion-duration-toast-entry)_var(--comp-motion-easing-toast-entry)_forwards]
          iris:data-[swipe=cancel]:translate-y-0
          iris:data-[swipe=cancel]:transition-[transform_var(--comp-motion-duration-toast-entry)_var(--comp-motion-easing-toast-entry)]
          iris:data-[swipe=move]:translate-y-[var(--radix-toast-swipe-move-y)]
        `
      }
    },
    type: {
      info: {},
      confirm: {},
      error: {}
    }
  },
  defaultVariants: {
    type: "info"
  }
});

export { styles as default };
